import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function DialogCalculatePlan({ task, open, onCancel }) {

  const close = () => {
    onCancel();
  };

  const handleCalculatePlanPreBaseline = () => {
    task.applyDistributionPreBaseline(task.distribution.code);
    close();
  };

  const handleCalculatePlanFromStart = () => {
    task.applyDistribution(task.distribution.code);
    close();
  };

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Calculate Plan</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please select the starting point of the plan calculation:
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleCalculatePlanFromStart} color="primary">
          Task Start Period
        </Button>
        <Button onClick={handleCalculatePlanPreBaseline} color="primary">
          Period After Latest PreBaseline
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogCalculatePlan;